<template>
  <div class="teen-page teen11">
    <div class="header">
      <h1>甲骨文：汉字的起源</h1>
    </div>

    <div class="container">
      <div class="img-box">
        <img src="https://img.moliaos.com/v/teen/teen_11.png" alt="甲骨文">
        <div class="caption">甲骨文，中国最早的成熟文字</div>
      </div>

      <h2>一、 发现历程</h2>
      <p>甲骨文是中国商朝时期刻在龟甲和兽骨上的文字，是目前发现的中国最早的成熟文字。1899年，金石学家王懿荣在中药"龙骨"上发现了甲骨文，这一发现震惊了学术界。</p>

      <h2>二、 文字特点</h2>
      <p>甲骨文的字形像图画一样，生动形象。它已经具备了汉字的基本结构，包括象形、会意、形声等造字方法。甲骨文主要记录了商朝的占卜活动和祭祀仪式。</p>

      <div class="img-box">
        <img src="https://img.moliaos.com/v/teen/teen_11.png" alt="汉字演变">
        <div class="caption">汉字从甲骨文到现代汉字的演变历程</div>
      </div>

      <h2>三、 历史价值</h2>
      <p>甲骨文的发现证明了商朝的存在，为研究中国古代历史提供了珍贵的资料。它不仅是研究汉字起源的重要依据，也是了解商朝社会、经济、文化的重要窗口。</p>

      <h2>四、 文化意义</h2>
      <p>甲骨文是中华文化的瑰宝，它承载着三千多年的历史记忆。从甲骨文到今天的汉字，中华文明一脉相承，从未中断。</p>

      <div class="quote-box">
        "一片甲骨惊天下。" —— 甲骨文发现的意义
      </div>

      <h2>五、 保护与研究</h2>
      <p>目前已发现的甲骨文约有15万片，包含约4500个单字。学者们一直在致力于甲骨文的研究和破译工作，让更多的人了解这一古老文字的魅力。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Teen11'
}
</script>

<style scoped>
.teen-page {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  margin: 0;
  background: #f4e4bc;
  line-height: 1.8;
}

.header {
  background: linear-gradient(135deg, #8b4513 0%, #a0522d 100%);
  color: white;
  padding: 30px 20px;
  text-align: center;
}

.container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
}

h1 {
  margin: 0;
  font-size: 1.6rem;
}

h2 {
  color: #5d3a1a;
  border-bottom: 2px solid #cd853f;
  padding-bottom: 8px;
  margin-top: 30px;
  font-size: 1.2rem;
}

p {
  text-indent: 2em;
  margin-bottom: 20px;
  text-align: justify;
}

.img-box {
  text-align: center;
  margin: 25px 0;
}

.img-box img {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

.caption {
  font-size: 0.85rem;
  color: #666;
  margin-top: 10px;
}

.quote-box {
  background: #faf0e6;
  padding: 20px;
  border-left: 4px solid #8b4513;
  margin: 25px 0;
  font-style: italic;
  color: #333;
}
</style>